export default "__VITE_ASSET__D4VpJAIY__"